<life-di-nav></life-di-nav>
<lifedi-breadcrumb></lifedi-breadcrumb>

<div *ngIf="isLoading">
  <div
    style="position: fixed; z-index: 900; width: 100vw; height: 100vh; opacity: 80; top: 0; left: 0; background: #e8e8e880;">
  </div>
  <mat-spinner class="spinner-center" style="z-index: 1000;"></mat-spinner>
</div>

<div *ngIf="!isEdit" class="container">
  <h1 class="text-center lifedi-color">
    แบบทดสอบ
  </h1>
  <form [formGroup]="measureForm">
    <div class="form-group row">
      <label for="language" class="col-1 col-form-label">ภาษา</label>
      <div class="col-1">
        <select class="custom-select" id="language" formControlName="language" Disabled>
          <option value="TH">TH</option>
          <option value="EN">EN</option>
        </select>
      </div>
      <label for="status" class="col-1 col-form-label">สถานะ<lifedi-require></lifedi-require></label>
      <div class="col-2">
        <select class="custom-select" id="status" formControlName="status">
          <option value="" selected disabled hidden>เลือกสถานะ</option>
          <option value="public" selected>Public</option>
          <option value="private">Private</option>
        </select>
      </div>
      <label for="font" class="col-2 col-form-label">ฟอนต์แบบทดสอบ<lifedi-require></lifedi-require></label>
      <div class="col-3">
        <select class="custom-select" id="font" formControlName="font">
          <option value="" selected disabled hidden>เลือกฟอนต์</option>
          <option *ngFor="let l of font" [value]="l">{{ l }}</option>
        </select>
      </div>
    </div>
    <div class="form-group row">
      <label for="name" class="col-2 col-form-label">ชื่อแบบทดสอบ<lifedi-require></lifedi-require></label>
      <div class="col-10">
        <input type="text" class="form-control" id="name" formControlName="name" autocomplete="off">
      </div>
    </div>
    <div class="form-group row">
      <label for="type" class="col-2 col-form-label">ประเภทแบบทดสอบ<lifedi-require></lifedi-require></label>
      <div class="col-10">
        <select class="custom-select" id="type" formControlName="type">
          <option value="" selected disabled hidden>เลือกแบบทดสอบ</option>
          <option *ngFor="let t of type">{{t.TYPE_NAME}}</option>
        </select>
      </div>
    </div>
    <div class="form-group row">
      <label for="type" class="col-2 col-form-label">ศูนย์ย่อย</label>
      <div class="col-10">
        <nz-select nzMode="multiple" [nzTokenSeparators]="[',']" #tag [(ngModel)]="LN_TAG"
          [ngModelOptions]="{standalone: true}" [change]="patchLearning(tag, measureForm)" style="width: 100%"
          [compareWith]="compareLNFn">
          <nz-option *ngFor="let center of allLearningCenter" [nzLabel]="center.CENTER_NAME"
            [nzValue]="center"></nz-option>
        </nz-select>
      </div>
    </div>
    <div class="form-group row">
      <label for="description" class="col-2 col-form-label">รายละเอียดแบบทดสอบ<lifedi-require></lifedi-require></label>
      <div class="col-10">
        <angular-editor id="_content" formControlName="description" placeholder="ใส่เนื้อหาแบบทดสอบ"
          style="margin: 0 auto;" [config]="editorConfig">
        </angular-editor>
      </div>
    </div>
    <div class="form-group row">
      <label for="measureImg" class="col-2 col-form-label">รูปปก</label>
      <div class="col-6">
        <div class="custom-file">
          <input type="file" class="custom-file-input" id="measureImg" accept=".png, .jpg, .jpeg"
            (change)="onCoverSelected($event, measureForm)">
          <label *ngIf="!measureImg" class="custom-file-label" for="measureImg">Choose file</label>
          <label *ngIf="measureImg" class="custom-file-label" for="measureImg">{{ measureImg }}</label>
        </div>
      </div>
      <button *ngIf="measureImg" mat-icon-button style="display: inline;" (click)="deleteMeasureImg(measureForm)">
        <span class="text-danger">✖</span>
      </button>
    </div>
    <div class="form-group row">
      <label for="date" class="col-2 col-form-label">วันเวลาเปิดแบบทดสอบ<lifedi-require></lifedi-require></label>
      <div class="col-4">
        <input [attr.disabled]="measureForm.value.alwaysOpen ? true : null" id="date" class="form-control"
          date-format="dd-MM-yyyy HH:mm:ss" formControlName="date" [selectMode]="'range'"
          [owlDateTimeTrigger]="dtPicker" [owlDateTime]="dtPicker" [rangeSeparator]="'-'" dateFormat="dd-MM-yyyy"
          autocomplete="off">
        <owl-date-time [pickerType]="'calendar'" #dtPicker></owl-date-time>
      </div>
      <div class="col-2 justify-content-center align-self-center col-form-label">
        <section>
          <mat-checkbox id="alwaysOpen" color="primary" formControlName="alwaysOpen"
            (click)="clearValueMeasureDate(measureForm)" [(ngModel)]="measureForm.value.alwaysOpen">
            เปิดตลอด
          </mat-checkbox>
        </section>
      </div>
    </div>
    <div class="form-group row">
      <label for="coin" class="col-2 col-form-label">Token<lifedi-require></lifedi-require></label>
      <div class="col-3">
        <input type="number" class="form-control" formControlName="coin" min="0" id="coin"
          (keyup)="checkMoreThanZero($event)">
      </div>
    </div>
    <div class="form-group row">
      <label for="courseSuggest" class="col-2 col-form-label">คอร์สแนะนำ</label>
      <div class="col-7">
        <nz-select nzMode="nzShowSearch" [nzTokenSeparators]="[',']" style="width: 100%;" #value
          [change]="patchSuggestCourse(value, false)">
          <nz-option *ngFor="let option of suggestCourse" [nzLabel]="option.COURSE_NAME" [nzValue]="option">
          </nz-option>
        </nz-select>
      </div>
    </div>
    <div class="form-group row">
      <label for="timeMeasureAgain" class="col-2 col-form-label">ทำแบบทดสอบได้อีกครั้งภายใน<lifedi-require>
        </lifedi-require></label>
      <div class="col-2">
        <input type="number" class="form-control" id="timeMeasureAgain" formControlName="timeMeasureAgain"
          autocomplete="off" min="0" step="1" ngDefaultControl (keyup)="checkMoreThanZero($event)">
      </div>
      <label class="col-1 col-form-label">วัน</label>
    </div>

    <div class="form-group row">
      <div class="col-2">
        <mat-checkbox (ngModelChange)="clearInformant(measureForm)" id="multi_informant" class="col p-0" color="primary"
          formControlName="multi_informant">
          Multi Informant
        </mat-checkbox>
      </div>
      <div class="col-10" *ngIf="measureForm.value.multi_informant">
        <nz-select nzMode="tags" [(ngModel)]="informant_list" [ngModelOptions]="{standalone: true}"
          (ngModelChange)="patchMultiInformantValue()" style="width: 100%;">
          <nz-option></nz-option>
        </nz-select>
      </div>
    </div>

    <div *ngIf="measureForm.value.multi_informant" class="form-group row">
      <div class="col-2">
        <mat-checkbox id="showInformant" class="col p-0" color="primary" formControlName="showInformant">
          แสดงผลผู้มีส่วนร่วมในแบบทดสอบ
        </mat-checkbox>
      </div>
    </div>

    <div class="d-flex justify-content-center">
      <p class="text-center text-danger">
        หากเปลี่ยนแบบทดสอบเป็น Multi Informant <br>
        ต้องลบและสร้างคำถามใหม่
      </p>
    </div>

    <div *ngIf="isAddMeasure && measureDetail">
      <div *ngFor="let q of measureDetail; let i = index;">
        <div class="row justify-content-center">
          <div class="col-10">
            <div class="col-12 text-right actionButton">
              <button mat-icon-button>
                <img src="../../../../assets/edit.png" style="width: 25px;"
                  (click)="editQuestion(q, measureForm.value.multi_informant)">
              </button>
              <button mat-icon-button>
                <img src="../../../../assets/close.png" style="width: 25px;" (click)="deleteQuestion(q.ID)">
              </button>
            </div>
            <div *ngIf="q.TYPE === 'multi_choice'">
              <lifedi-multiple-choice [multipleChoice]="q" [isAutoNumber]="false" [questionNumber]="i+1">
              </lifedi-multiple-choice>
            </div>
            <div *ngIf="q.TYPE === 'rating'">
              <lifedi-rating-choice [ratingChoice]="q" [isAutoNumber]="false" [questionNumber]="i+1">
              </lifedi-rating-choice>
            </div>
            <div *ngIf="q.TYPE === 'ranking'">
              <lifedi-ranking-choice [ranking]="q" [isAutoNumber]="false" [questionNumber]="i+1">
              </lifedi-ranking-choice>
            </div>
            <div *ngIf="q.TYPE === 'most/least'">
              <lifedi-most-least-choice [mostLeastData]="q" [isAutoNumber]="false" [questionNumber]="i+1">
              </lifedi-most-least-choice>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row justify-content-center">
      <lifedi-btn *ngIf="!isAddMeasure && measureForm.valid" lable="เพิ่มคำถาม" class="mt-3 mb-3"
        customStyle="padding: 0 25px; background: #005C3D; color:#FFFFFF"
        (click)="createMeasure(measureForm.value, measureForm.value.multi_informant)">
      </lifedi-btn>

      <button *ngIf="isAddMeasure && measureForm.valid" mat-mini-fab class="img"
        (click)="addQuestion(measureForm.value, measureForm.value.multi_informant)"
        [style.backgroundImage]="'url(https://lifedi2021-production.s3.ap-southeast-1.amazonaws.com/measure/add.png)'">
      </button>

      <lifedi-btn *ngIf="!measureForm.valid" lable="เพิ่มคำถาม" class="mt-3 mb-3" disabled="true"
        customStyle="padding: 0 25px; color:#FFFFFF">
      </lifedi-btn>
    </div>

    <div class="row justify-content-center">
      <lifedi-btn *ngIf="isAddMeasure && measureForm.valid && measureDetail.length > 0" lable="Save Draft"
        class="mx-2 my-3" customStyle="padding: 0 25px; background: #005C3D; color:#FFFFFF"
        (click)="saveMeasure(measureForm.value, 'savedraft')">
      </lifedi-btn>
      <lifedi-btn *ngIf="isAddMeasure && measureForm.valid && measureDetail.length > 0" lable="เผยแพร่"
        class="mx-2 my-3" customStyle="padding: 0 25px; background: #005C3D; color:#FFFFFF"
        (click)="saveMeasure(measureForm.value, 'confirm')">
      </lifedi-btn>

      <lifedi-btn *ngIf="isAddMeasure && measureForm.valid && measureDetail.length === 0" lable="Save Draft"
        class="mx-2 my-3" customStyle="padding: 0 25px; color:#FFFFFF" disabled="true">
      </lifedi-btn>
      <lifedi-btn *ngIf="isAddMeasure && measureForm.valid && measureDetail.length === 0" lable="เผยแพร่"
        class="mx-2 my-3" customStyle="padding: 0 25px; color:#FFFFFF" disabled="true">
      </lifedi-btn>
    </div>
  </form>
</div>



<div *ngIf="isEdit && measureDetail" class="container">
  <h1 class="text-center lifedi-color">
    แก้ไขแบบทดสอบ
  </h1>
  <form [formGroup]="measureForm">
    <div class="form-group row">
      <label for="language" class="col-1 col-form-label">ภาษา</label>
      <div class="col-1">
        <select class="custom-select" id="language" formControlName="language" Disabled>
          <option value="TH">TH</option>
          <option value="EN">EN</option>
        </select>
      </div>
      <label for="status" class="col-1 col-form-label">สถานะ<lifedi-require></lifedi-require></label>
      <div class="col-2">
        <select class="custom-select" id="status" formControlName="status">
          <option value="" selected disabled hidden>เลือกสถานะ</option>
          <option value="public" selected>Public</option>
          <option value="private">Private</option>
        </select>
      </div>
      <label for="font" class="col-2 col-form-label">ฟอนต์แบบทดสอบ<lifedi-require></lifedi-require></label>
      <div class="col-3">
        <select class="custom-select" id="font" formControlName="font">
          <option value="" selected disabled hidden>เลือกฟอนต์</option>
          <option *ngFor="let l of font" [value]="l">{{ l }}</option>
        </select>
      </div>
    </div>
    <div class="form-group row">
      <label for="name" class="col-2 col-form-label">ชื่อแบบทดสอบ<lifedi-require></lifedi-require></label>
      <div class="col-10">
        <input type="text" class="form-control" id="name" formControlName="name" autocomplete="off">
      </div>
    </div>
    <div class="form-group row">
      <label for="type" class="col-2 col-form-label">ประเภทแบบทดสอบ<lifedi-require></lifedi-require></label>
      <div class="col-10">
        <select class="custom-select" id="type" formControlName="type">
          <option value="" selected disabled hidden>เลือกแบบทดสอบ</option>
          <option *ngFor="let t of type" [value]="t.TYPE_NAME">{{t.TYPE_NAME}}</option>
        </select>
      </div>
    </div>
    <div class="form-group row">
      <label for="type" class="col-2 col-form-label">ศูนย์ย่อย</label>
      <div class="col-10">
        <nz-select nzMode="multiple" [nzTokenSeparators]="[',']" #tag [(ngModel)]="LN_TAG"
          [ngModelOptions]="{standalone: true}" [change]="patchLearning(tag, measureForm)" style="width: 100%"
          [compareWith]="compareLNFn">
          <nz-option *ngFor="let center of allLearningCenter" [nzLabel]="center.CENTER_NAME"
            [nzValue]="center"></nz-option>
        </nz-select>
      </div>
    </div>
    <div class="form-group row">
      <label for="description" class="col-2 col-form-label">รายละเอียดแบบทดสอบ<lifedi-require></lifedi-require></label>
      <div class="col-10">
        <angular-editor id="_content" formControlName="description" placeholder="ใส่เนื้อหาแบบทดสอบ"
          style="margin: 0 auto;" [config]="editorConfig">
        </angular-editor>
      </div>
    </div>
    <div class="form-group row">
      <label for="measureImg" class="col-2 col-form-label">รูปปก</label>
      <div class="col-6">
        <div class="custom-file">
          <input type="file" class="custom-file-input" id="measureImg" accept=".png, .jpg, .jpeg"
            (change)="onCoverSelected($event, measureForm)">
          <label *ngIf="!measureImg" class="custom-file-label" for="measureImg">Choose file</label>
          <label *ngIf="measureImg" class="custom-file-label" for="measureImg">{{ measureImg }}</label>
        </div>
      </div>
      <button *ngIf="measureImg" mat-icon-button style="display: inline;" (click)="deleteMeasureImg(measureForm)">
        <span class="text-danger">✖</span>
      </button>
    </div>
    <div class="form-group row">
      <label for="date" class="col-2 col-form-label">วันเวลาเปิดแบบทดสอบ<lifedi-require></lifedi-require></label>
      <div class="col-4">
        <input [attr.disabled]="measureForm.value.alwaysOpen ? true : null" id="date" class="form-control"
          date-format="dd-MM-yyyy HH:mm:ss" formControlName="date" [selectMode]="'range'"
          [owlDateTimeTrigger]="dtPicker" [owlDateTime]="dtPicker" [rangeSeparator]="'-'" dateFormat="dd-MM-yyyy"
          autocomplete="off">
        <owl-date-time [pickerType]="'calendar'" #dtPicker></owl-date-time>
      </div>
      <div class="col-2 justify-content-center align-self-center col-form-label">
        <section>
          <mat-checkbox id="alwaysOpen" color="primary" formControlName="alwaysOpen"
            (click)="clearValueMeasureDate(measureForm)">
            เปิดตลอด
          </mat-checkbox>
        </section>
      </div>

    </div>
    <div class="form-group row">
      <label for="coin" class="col-2 col-form-label">Token<lifedi-require></lifedi-require></label>
      <div class="col-3">
        <input type="number" class="form-control" formControlName="coin" min="0" id="coin"
          (keyup)="checkMoreThanZero($event)">
      </div>
    </div>
    <div class="form-group row">
      <label for="courseSuggest" class="col-2 col-form-label">คอร์สแนะนำ</label>
      <div class="col-7">
        <nz-select nzMode="nzShowSearch" [nzTokenSeparators]="[',']" style="width: 100%;" #value
          formControlName="courseSuggest" [change]="patchSuggestCourse(value, false)"
          [compareWith]="compareSuggestCourse">
          <nz-option *ngFor="let option of suggestCourse" [nzLabel]="option.COURSE_NAME" [nzValue]="option">
          </nz-option>
        </nz-select>
      </div>
    </div>
    <div class="form-group row">
      <label for="timeMeasureAgain" class="col-2 col-form-label">ทำแบบทดสอบได้อีกครั้งภายใน<lifedi-require>
        </lifedi-require></label>
      <div class="col-2">
        <input type="number" class="form-control" id="timeMeasureAgain" formControlName="timeMeasureAgain"
          autocomplete="off" min="0" step="1" ngDefaultControl (keyup)="checkMoreThanZero($event)">
      </div>
      <label class="col-1 col-form-label">วัน</label>
    </div>

    <div class="form-group row">
      <div class="col-2">
        <mat-checkbox (ngModelChange)="clearInformant(measureForm)" id="multi_informant" class="col p-0" color="primary"
          formControlName="multi_informant" [disabled]="true">
          Multi Informant
        </mat-checkbox>
      </div>
      <div class="col-10" *ngIf="measureForm.value.multi_informant">
        <nz-select nzMode="tags" [(ngModel)]="informant_list" [ngModelOptions]="{standalone: true}"
          (ngModelChange)="patchMultiInformantValue()" style="width: 100%;" nzDisabled>
          <nz-option></nz-option>
        </nz-select>
      </div>
    </div>

    <div *ngIf="measureForm.value.multi_informant" class="form-group row">
      <div class="col-2">
        <mat-checkbox id="showInformant" class="col p-0" color="primary" formControlName="showInformant"
          [disabled]="true">
          แสดงผลผู้มีส่วนร่วมในแบบทดสอบ
        </mat-checkbox>
      </div>
    </div>

    <p *ngIf="measureStatus == 0" class="text-center text-danger">
      ** ไม่สามารถแก้ไขคำถาม คำตอบ ของแบบทดสอบได้ เนื่องจากเปิดให้ user ใช้งานแล้ว
      <span class="text-success">แต่ยังสามารถแก้ไขรายละเอียดแบบทดสอบได้ตามปกติ</span>
    </p>
    <div *ngIf="isAddMeasure && measureDetail">
      <div *ngFor="let q of measureDetail; let i = index;">
        <div class="row justify-content-center">
          <div class="col-10">
            <div *ngIf="measureStatus === 99" class="col-12 text-right actionButton">
              <button mat-icon-button>
                <img src="../../../../assets/edit.png" style="width: 25px;"
                  (click)="editQuestion(q, measureForm.value.multi_informant)">
              </button>
              <button mat-icon-button>
                <img src="../../../../assets/close.png" style="width: 25px;" (click)="deleteQuestion(q.ID)">
              </button>
            </div>
            <div *ngIf="q.TYPE === 'multi_choice'">
              <lifedi-multiple-choice [multipleChoice]="q" [isAutoNumber]="false" [questionNumber]="i+1">
              </lifedi-multiple-choice>
            </div>
            <div *ngIf="q.TYPE === 'rating'">
              <lifedi-rating-choice [ratingChoice]="q" [isAutoNumber]="false" [questionNumber]="i+1">
              </lifedi-rating-choice>
            </div>
            <div *ngIf="q.TYPE === 'ranking'">
              <lifedi-ranking-choice [ranking]="q" [isAutoNumber]="false" [questionNumber]="i+1">
              </lifedi-ranking-choice>
            </div>
            <div *ngIf="q.TYPE === 'most/least'">
              <lifedi-most-least-choice [mostLeastData]="q" [isAutoNumber]="false" [questionNumber]="i+1">
              </lifedi-most-least-choice>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div *ngIf="measureStatus === 99" class="row justify-content-center">
      <button mat-mini-fab class="img" (click)="addQuestion(measureForm.value, measureForm.value.multi_informant)"
        [style.backgroundImage]="'url(https://lifedi2021-production.s3.ap-southeast-1.amazonaws.com/measure/add.png)'">
      </button>
    </div>

    <div class=" row justify-content-center">
      <lifedi-btn *ngIf="isAddMeasure && measureForm.valid && measureDetail.length > 0 && measureStatus === 99"
        lable="Save Draft" class="mx-2 my-3" customStyle="padding: 0 25px; background: #005C3D; color:#FFFFFF"
        (click)="saveMeasure(measureForm.value, 'savedraft')">
      </lifedi-btn>
      <lifedi-btn *ngIf="isAddMeasure && measureForm.valid && measureDetail.length > 0" lable="เผยแพร่"
        class="mx-2 my-3" customStyle="padding: 0 25px; background: #005C3D; color:#FFFFFF"
        (click)="saveMeasure(measureForm.value, 'confirm')">
      </lifedi-btn>

      <lifedi-btn
        *ngIf="((isAddMeasure && measureForm.valid && measureDetail.length === 0) || !measureForm.valid) && measureStatus === 99"
        lable="Save Draft" class="mx-2 my-3" customStyle="padding: 0 25px; color:#FFFFFF" disabled="true">
      </lifedi-btn>
      <lifedi-btn *ngIf="(isAddMeasure && measureForm.valid && measureDetail.length === 0) || !measureForm.valid"
        lable="เผยแพร่" class="mx-2 my-3" customStyle="padding: 0 25px; color:#FFFFFF" disabled="true">
      </lifedi-btn>
    </div>
  </form>
</div>